import React from "react";
import { Box, Button } from "@mui/material";
import {
  Edit as EditIcon,
  Delete as DeleteIcon,
  Undo as UndoIcon,
} from "@mui/icons-material";

const OneTimeUserTableDisplay = ({
  currentRows,
  page,
  handleEditClick,
  handleDeleteEmployee,
  handleUndoDelete,
  totalPages,
  renderPageNumbers,
  handlePageChange,
  rowsPerPage,
}) => {
  // 🎨 Button Styles (unchanged)
  const buttonSx = {
    minWidth: "40px",
    height: "36px",
    padding: "0 12px",
    fontWeight: 600,
    fontSize: "0.875rem",
    textTransform: "none",
    borderRadius: "6px",
    boxShadow: "none",
  };

  const activeButtonSx = {
    ...buttonSx,
    background: "#0191c8",
    color: "#fff",
    "&:hover": { background: "#0191c8" },
  };

  const outlinedButtonSx = {
    ...buttonSx,
    border: "2px solid #0191c8",
    color: "#0191c8",
    background: "transparent",
    "&:hover": {
      background: "#0191c8",
      color: "#fff",
    },
  };

  return (
    <>
      <Box sx={{ 
        maxHeight: "420px", 
        overflowY: "auto",
        overflowX: "auto"
      }}>
        <table className="pd-table" style={{ 
          width: "100%", 
          tableLayout: "fixed",
          minWidth: "600px"
        }}>
          <thead>
            <tr>
              <th style={{ width: "80px" }}>S.No</th>
              <th style={{ width: "140px" }}>First Name</th>
              <th style={{ width: "140px" }}>Last Name</th>
              <th style={{ width: "220px" }}>Email</th>
              <th style={{ width: "160px" }}>Departments</th>
              <th style={{ width: "120px" }}>Actions</th>
            </tr>
          </thead>

          <tbody>
            {currentRows.length === 0 ? (
              <tr>
                <td colSpan="6" align="center">
                  No data found
                </td>
              </tr>
            ) : (
              currentRows.map((user, index) => (
                <tr
                  key={index}
                  style={{
                    opacity: user.isActive ? 1 : 0.5,
                    textDecoration: user.isActive ? "none" : "line-through",
                    backgroundColor: user.isActive ? "inherit" : "#f5f5f5",
                  }}
                >
                  <td>{(page - 1) * rowsPerPage + index + 1}</td>
                  <td>{user.firstName}</td>
                  <td>{user.lastName}</td>
                  <td
                    style={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {user.email}
                  </td>
                  <td>{user.departmentName}</td>
                  <td>
                    <button
                      className="action-icon"
                      onClick={() =>
                        handleEditClick((page - 1) * rowsPerPage + index)
                      }
                      disabled={!user.isActive}
                      title="Edit"
                    >
                      <EditIcon fontSize="small" />
                    </button>

                    {user.isActive ? (
                      <button
                        className="action-icon"
                        onClick={() => handleDeleteEmployee(user.email)}
                        title="Delete"
                      >
                        <DeleteIcon fontSize="small" />
                      </button>
                    ) : (
                      <button
                        className="action-icon"
                        onClick={() => handleUndoDelete(user.email)}
                        title="Undo"
                      >
                        <UndoIcon fontSize="small" />
                      </button>
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </Box>

      {/* Responsive Pagination */}
      <Box className="pd-pagination" sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
        mt: 2,
        width: '100%'
      }}>
        {/* Previous */}
        <button
          className="btn-negative"
          disabled={page === 1}
          onClick={() => handlePageChange(page - 1)}
          style={{ width: { xs: '100%', sm: 'auto' } }}
        >
          Previous
        </button>

        {/* Page Numbers */}
        <div className="pd-page-numbers" style={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          gap: '2px'
        }}>
          {renderPageNumbers().map((pageNum, index) => (
            <button
              key={index}
              disabled={pageNum === "..."}
              onClick={() =>
                typeof pageNum === "number" && handlePageChange(pageNum)
              }
              className={`pg-type-btn ${pageNum === page ? "active" : ""}`}
              style={{
                minWidth: '36px',
                height: '36px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              {pageNum}
            </button>
          ))}
        </div>

        {/* Next */}
        <button
          className="btn-negative"
          disabled={page === totalPages}
          onClick={() => handlePageChange(page + 1)}
          style={{ width: { xs: '100%', sm: 'auto' } }}
        >
          Next
        </button>
      </Box>
    </>
  );
};

export default OneTimeUserTableDisplay;